import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import { IMG } from '../../data/media';
import Reveal from '../layout/Reveal';

// Tile sizes and colours are fixed per product, so Tailwind sees full class names.
const TILES = [
  { to: '/services/life-insurance', key: 'tLife', img: IMG.life, cls: 'col-span-2 row-span-2 bg-sky', cta: 'text-brand', big: true },
  { to: '/services/health-insurance', key: 'tHealth', img: IMG.health, cls: 'bg-mint', cta: 'text-emerald-700' },
  { to: '/services/vehicle-insurance', key: 'tMotor', img: IMG.vehicle, cls: 'bg-orange-50', cta: 'text-saffron' },
  { to: '/investments', key: 'tMf', img: IMG.invest, cls: 'col-span-2 bg-ink text-white', cta: 'text-amber-200', invest: true },
  { to: '/services/home-insurance', key: 'tHome', img: IMG.home, cls: 'bg-violet-50', cta: 'text-violet-700' },
  { to: '/services/travel-insurance', key: 'tTravel', img: IMG.travel, cls: 'bg-cyan-50', cta: 'text-cyan-700' },
  { to: '/services/business-insurance', key: 'tBiz', img: IMG.business, cls: 'col-span-2 bg-amber-50', cta: 'text-amber-700' },
];

export default function ProductBento() {
  const { t } = useLang();
  return (
    <section className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="max-w-2xl mb-10"><p className="kicker text-brand">{t('pKick')}</p><h2 className="h2">{t('pTitle')}</h2></Reveal>
        <Reveal className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 auto-rows-[150px] sm:auto-rows-[190px]">
          {TILES.map((x) => (
            <Link key={x.to} to={x.to}
              className={`group relative overflow-hidden rounded-3xl p-5 sm:p-6 flex flex-col justify-between transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-18px_rgba(15,27,61,.25)] ${x.cls}`}>
              <div className="relative z-10 max-w-[70%]">
                {x.big && <div className="text-xs font-bold text-brand">{t('tLifeK')}</div>}
                {x.invest && <div className="text-xs font-bold text-amber-200">{t('tMfK')}</div>}
                <h3 className={`font-extrabold ${x.big ? 'text-2xl sm:text-3xl mt-1' : 'text-base sm:text-lg'}`}>{t(x.key)}</h3>
                {x.big && <p className="mt-2 text-slate-600 text-sm sm:text-base">{t('tLifeP')}</p>}
              </div>
              <span className={`relative z-10 text-xs sm:text-sm font-bold ${x.cta}`}>{x.invest ? t('tMfC') : t('callback')}</span>
              <img src={x.img} alt="" aria-hidden="true" loading="lazy" decoding="async"
                className={`absolute select-none pointer-events-none drop-shadow-xl transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6 ${x.big ? '-right-6 -bottom-8 w-44 sm:w-72' : 'right-0 bottom-0 w-20 sm:w-28'}`} />
            </Link>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
